import { IBusinessConfigs } from '../_Common/Const/BusinessConfigs';
import { initConst } from '../../../Utils/utils';

const OFBusinessConfig = initConst<IBusinessConfigs>(() => ({
  OFOrder: {
    defaultColumns: [
      { attributeDef: 'ORDERNR', caption: 'Ordernr', header: true },
      { attributeDef: 'STATUS', caption: 'Status' },
      { attributeDef: 'NAMN', caption: 'Kund' },
      { attributeDef: 'Kund.KUNDNR_KONTONR', caption: 'Kundnr' },
      { attributeDef: 'ORDERDATUM', caption: 'Orderdat' },
      { attributeDef: 'TotBelopp', caption: 'Belopp' },
      { attributeDef: 'TotFakturaMoms', caption: 'Moms' },
      { attributeDef: 'BESTALLNINGSNR', caption: 'Fakturarubrik' },
      { attributeDef: 'KUNDREFERENS', caption: 'Kundreferens' },
      { attributeDef: 'RUBRIK', caption: 'Intern rubrik' },
      { attributeDef: 'CO', caption: 'c/o' },
      { attributeDef: 'ADRESS', caption: 'Adress' },
      { attributeDef: 'POSTNR', caption: 'Postnr' },
      { attributeDef: 'ORT', caption: 'Ort' },
      { attributeDef: 'MOMS', caption: 'Moms' },
      { attributeDef: 'RABATT', caption: 'Rabatt' },
      { attributeDef: 'Kund.BankkontonrTot', caption: 'Bankkontonr' },
      { attributeDef: 'KLARFAKT', caption: 'Klar för fakturering' },
      { attributeDef: 'FAKTURATEXT', caption: 'Fakturatext' },
    ],
  },
  OFOrderunderlag: {
    defaultColumns: [
      { attributeDef: 'FIL_DATUM', caption: 'Datum' },
      { attributeDef: 'FIL_LOPNR', caption: 'Löpnr' },
      { attributeDef: 'STATUS', caption: 'Status' },
      { attributeDef: 'DATUM_SKAPAD', caption: 'Importerad,  datum' },
      { attributeDef: 'SIGN_SKAPAD', caption: 'Importerad av' },
      { attributeDef: 'DATUM_BACKAD', caption: 'Backad,  datum' },
      { attributeDef: 'FIL_NAMN', caption: 'Importerad från fil' },
      { attributeDef: 'SIGN_BACKAD', caption: 'Backad av' },
    ],
  },
  OFPrisavtal: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'FRANDATUM', caption: 'Fråndatum' },
      { attributeDef: 'TILLDATUM', caption: 'Tilldatum' },
    ],
  },
  OFOrderrad: {
    defaultColumns: [
      { attributeDef: 'Ordern.ORDERNR', caption: 'Ordernr' },
      { attributeDef: 'Ordern.ORDERDATUM', caption: 'Orderdatum' },
      { attributeDef: 'ArtNrFaktText', caption: 'Artikelnr' },
      { attributeDef: 'TrimBenamning', caption: 'Benämning' },
      { attributeDef: 'BESTANTAL', caption: 'Beställt' },
      { attributeDef: 'RadBelopp2', caption: 'Belopp' },
      { attributeDef: 'Ordern.Kund.KUNDNR_KONTONR', caption: 'Kundnr' },
      { attributeDef: 'Ordern.NAMN', caption: 'Kundnamn' },
      { attributeDef: 'ArtikelTextgrupp', caption: 'Artikelgrupp' },
      { attributeDef: 'Ordern.Grupp.BENAMNING', caption: 'Faktgrupp' },
      { attributeDef: 'Fakturanr', caption: 'Faktnr' },
      { attributeDef: 'Slutfakturadatum', caption: 'Fakt dat' },
      { attributeDef: 'Kontostrang', caption: 'Intäktskonto' },
      { attributeDef: 'Kontoben', caption: 'Kontobenämning' },
      {
        attributeDef: 'Ordern.Kund.KundKategori.KUNDKAT_KOD',
        caption: 'Kundkategorikod',
      },
      { attributeDef: 'Artikel.SORTIMENT', caption: 'Sortiment' },
      { attributeDef: 'LEVANTAL', caption: 'Levererat' },
    ],
  },
  OFRanteomgang: {
    defaultColumns: [
      { attributeDef: 'ID', caption: 'Ränteomgång' },
      { attributeDef: 'RUBRIK', caption: 'Rubrik' },
      { attributeDef: 'StatusBen', caption: 'Status' },
      { attributeDef: 'DATUM_SKAPAD', caption: 'Skapad datum' },
      { attributeDef: 'SIGN_SKAPAD', caption: 'Skapad av' },
      { attributeDef: 'DATUM_BACKAD', caption: 'Backad datum' },
      { attributeDef: 'SIGN_BACKAD', caption: 'Backad av' },
    ],
  },
  OFOrderkategori: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'CalcIntaktskonto', caption: 'Intäktskonto' },
      { attributeDef: 'CalcIntaktskontoben', caption: 'Kontobenämning' },
    ],
  },
}));

export default OFBusinessConfig;
